import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=c257d018&"
import script from "./relationship.vue?vue&type=script&lang=js&"
export * from "./relationship.vue?vue&type=script&lang=js&"
import style0 from "./relationship.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "relationship.vue"
export default component.exports